<template>
  <div class="px-xl-5 mt-xl-5 px-lg-5 mt-lg-5 px-md-4 mt-md-3 px-sm-4 mt-sm-3 px-4 mt-3">
    <div class="row">
      <div class="col-12 d-flex justify-content-end flex-wrap">
        <div style="flex:1;" class="d-flex align-items-center">
          <h2 class="view-title">Editar producto o servicio</h2>
        </div>
        
        <div class="container-actions-dashboard d-flex justify-content-between mt-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
          <button class="btn btn-outlined mr-3 d-flex align-items-center" @click="backTo()">
            <img src="@/assets/icons/undo.svg" alt width="15px" class="mr-2" />
            Regresar
          </button>
          <button class="btn btn-save mr-2 d-flex align-items-center" @click="updateProduct()">
            <img src="@/assets/icons/guardar.svg" alt width="15px" class="mr-2" />
            Guardar cambios
          </button>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-12 mt-3">
        <p class="subtitle-info-section">Este producto o servicio podrá ser agregado dentro de tus cotizaciones en blanco o plantillas. Cuando lo utilices, cualquier ajuste que se haga dentro de esa cotización no afectará esta plantilla.</p>
      </div>
    </div>
    <section
      class="items cotizacion-wrapper mt-5"
      v-for="(item, index) in quote.items"
      :key="index"
    >
      <div class="col-xl-10 col-lg-10 cotizacion-card">
        <div class="item">
          <!-- Seccion de item de producto -->
          <div id="product" v-if="item.type === 'producto'">
            <quote-products
              :itemProduct="item"
              :indexProduct="index"
              :productsArray="productsArray"
              :productCategories="productCategories"
              :isTemplate="true"
              @change-value="handleChangeValueProducts"
            ></quote-products>
          </div>
          <!-- Fin de seccion de item de producto -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>


/* Import api */
import quoteService from "@/api/new_quotation";
import clientsService from "@/api/clients";
import itemsService from "@/api/items";

/* Import extras */
import methods from "@/mixins/methods";

/* Import components */
import QuoteProducts from "@/components/cotizacion/helpers/QuoteProducts";

export default {
  mixins: [methods],
  components: { QuoteProducts,},
  beforeMount() {
    this.idProduct = this.$route.params.productId;
    this.loadDefaultData();
  },
  data() {
    return {
      /* Setting mask money */
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 2,
        masked: false,
      },
      quote: {
        items: [],
      },
      idProduct: null,
      productsArray: [],
      productCategories: [],
    };
  },
  methods: {
    calculate(string, field, index) {
      let item = this.quote.items[index];

      try {
        let value = eval(string);
        field === "qty"
          ? (item.quantity.amount = parseFloat(value))
          : (item.price = parseFloat(value));
      } catch (error) {
        return parseFloat(string);
      }
      this.setTotal(index);
    },
    /* Setear total */
    setTotal(index) {
      let item = this.quote.items[index];
      item.total = parseFloat(this.getProductTotal(index));
    },
    /* Obtener total de un producto */
    getProductTotal(index) {
      let item = this.quote.items[index];
      return parseFloat(
        item.quantity.amount *
          item.price *
          (item.commission.active ? 1 + item.commission.amount / 100 : 1) *
          (item.discount.active ? 1 - item.discount.amount / 100 : 1)
      ).toFixed(2);
    },
    submitResult(event, index, type) {
      if (event) this.noResults = true;
      delete event.created;
      delete event.id;
      event.key = new Date().getTime();
      let addItem = this.formatItem(event, type);
      this.quote.items.splice(index, 1, addItem);
    },
    handleChangeValueProducts(payload) {
      switch (payload.field) {
        case "optional-select":
          this.quote.items[payload.index].optional.select = payload.value;
          break;
        case "optional-active":
          this.quote.items[payload.index].optional.active = payload.value;
          break;
        case "quantity-edit":
          this.quote.items[payload.index].quantity.edit = payload.value;
          break;
        case "discount-active":
          this.quote.items[payload.index].discount.active = payload.value;
          this.setTotal(payload.index);
          break;
        case "suscription-active":
          this.quote.items[payload.index].suscription.active = payload.value;
          this.setTotal(payload.index);
          break;
        case "commission-active":
          this.quote.items[payload.index].commission.active = payload.value;
          this.setTotal(payload.index);
          break;
        case "discount-amount":
          this.quote.items[payload.index].discount.amount = payload.value;
          this.setTotal(payload.index);
          break;
        case "comission-amount":
          this.quote.items[payload.index].commission.amount = payload.value;
          this.setTotal(payload.index);
          break;
        case "sucription-frecuency":
          this.quote.items[payload.index].suscription.frequency = payload.value;
          break;
        case "suscription-repetition":
          this.quote.items[payload.index].suscription.repetition =
            payload.value;
          break;
        case "quantity-amount":
          this.quote.items[payload.index].quantity.amount = payload.value;
          this.setTotal(payload.index);
          break;
        case "price":
          this.quote.items[payload.index][payload.field] = payload.value;
          this.setTotal(payload.index);
          break;

        default:
          this.quote.items[payload.index][payload.field] = payload.value;
          break;
      }
    },
    deleteImage(item, index) {
      item.attachments.splice(index, 1);
    },
    /* Agregar imagen a arreglo de imagenes de cada item */
    uploadImage(item) {
      let e = window.event;
      let file = e.target.files[0];
      let image = require("@/assets/icons/attachment.svg");
      if (file.type.indexOf("image") > -1) {
        var reader = new FileReader();
        reader.onload = function (e) {
          item.attachments.unshift({
            file: file,
            base64: e.target.result,
            name: file.name,
          });
        };
        reader.readAsDataURL(file);
      } else {
        item.attachments.unshift({
          file: file,
          base64: image,
          name: file.name,
        });
      }
    },
    loadDefaultData() {
      /* Obtener lista de productos */
      quoteService.getProductsList(null).then((response) => {
        var array = [];
        response.data.data.forEach((element) => {
          array.push(element);
        });
        this.productsArray = array;
      });

      clientsService.companies().then((response) => {
        this.productCategories = response.data.data;
      });

      itemsService.getProductItemData(this.idProduct).then((response) => {
        this.quote.items.push(this.formatItem(response.data.data, "product"));
        this.quote.items.forEach((element, index) => {
          this.calculate(element.price, 'price', index)
        });
      });
    },
    formatToSend() {
      let data = new FormData();
      data.append("sku", this.quote.items[0].sku);
      data.append("category_id", this.quote.items[0].category);
      data.append("name", this.quote.items[0].title);
      data.append("description", this.quote.items[0].description);
      data.append("IVA", this.quote.items[0].tax === true ? 1 : 0);
      data.append("unit_price", this.quote.items[0].price);
      data.append("quantity", this.quote.items[0].quantity.amount);
      data.append(
        "is_optional",
        this.quote.items[0].optional.active == true ? 1 : 0
      );
      data.append(
        "quantity_editable",
        this.quote.items[0].quantity.edit == true ? 1 : 0
      );
      data.append(
        "has_discount",
        this.quote.items[0].discount.active == true ? 1 : 0
      );
      data.append(
        "has_subscription",
        this.quote.items[0].suscription.active == true ? 1 : 0
      );
      data.append(
        "has_commission",
        this.quote.items[0].commission.active == true ? 1 : 0
      );

      let arrayAtatchments = [];
      if (this.quote.items[0].attachments.length > 0) {
        this.quote.items[0].attachments.forEach((element) => {
          if(element.file != null){
            arrayAtatchments.push(element.file);
          }else{
            arrayAtatchments.push(element.base64);
          }
        });
      }
      if (arrayAtatchments.length > 0) {
        arrayAtatchments.forEach((element, indexParent) => {
          data.append("attachments[" + indexParent + "]", element);
        });
      }

      /* Checar descuento */
      if (this.quote.items[0].discount.active == true) {
        data.append("discount", this.quote.items[0].discount.amount);
      }

      /* Checar comision */
      if(this.quote.items[0].commission.active == true){
        data.append("commission" , this.quote.items[0].commission.amount);
      }

      if(this.quote.items[0].suscription.active == true){
        data.append("frequency" , this.quote.items[0].suscription.repetition);
        data.append("period" , this.quote.items[0].suscription.frequency);
      }

      return data;
    },
    updateProduct() {
      if (this.quote.items[0].title == null ||this.quote.items[0].price == null) {
        this.$store.dispatch("showMessage", {
          action: "error",
          message: "Llena todos los campos requeridos",
        });
      } else {
        this.$store.dispatch("showLoader", { show: true });
        let data = this.formatToSend();
        itemsService.updateProductItem(this.idProduct,data).then(() => {
          this.$store.dispatch("showLoader", { show: false });
          this.$store.dispatch("showMessage", {
            action: "success",
            message: "Guardada correctamente",
          });
          this.quote.items[0].errors = null;
        }).catch(
          error => {
            let errorMsg = "";
            this.quote.items[0].errors = null;
            if(error.data.errors != null){
              Object.entries(error.data.errors).map(element =>{
                errorMsg += element[1] + "<br>";
              })
            }else{
              errorMsg = error.data.message;
            }
            this.quote.items[0].errors = {
              message: errorMsg
            }
            
          }
        );
      }
    },
    backTo() {
      this.$router.push("/items");
    },
  },
};
</script>

<style lang="scss" scoped>
.form-type {
  font-size: 2rem;
}

.title {
  font-size: 1.6rem;
  font-weight: bold;
  border-bottom: 1px solid #0c203d !important;
}

.form-control,
.blanck-input {
  border: 0;
  outline: 0;
  &:focus {
    box-shadow: 0 0 0 0 !important;
  }
}

.input-group {
  border-radius: 0.85rem;
}

.image-upload input {
  display: none;
}



.cotizacion-wrapper {
  margin-top: 30px;
}

.input-group-text {
  background-color: #d1dae6 !important;
  color: #0c203d;
  font-size: 0.75rem;
}

.description-options {
  border-bottom: 1px solid #c1c7d0;
  border-top: 1px solid #c1c7d0;
}

.input-blank {
  border: 0;
  background-color: transparent;
  box-shadow: 0 0 0 0 !important;
}

.product-id-input {
  background-color: #c1c7d0;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 12px 0 12px 0 !important;
  width: 200px;
}

.label-text {
  color: #0c203d;
  font-size: 0.75rem;
}

.dropdown-toggle::after {
  display: none;
}

.sku-section {
  border-radius: 12px;
  input {
    &::placeholder {
      font-size: 0.8rem;
      color: #ffffff;
    }
  }
}

.input-group-text,
.custom-select {
  border: 0;
}

select.custom-select {
  background: transparent url("../../assets/icons/abajo_blue.svg") no-repeat 95%
    center;
  &:focus {
    outline: none;
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>